module.exports = __webpack_public_path__ + "static/img/shezhi_jiaoyijilu.4f79420d.png";